
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summer-camp",
      function () {
        return require("private-next-pages/summer-camp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summer-camp"])
      });
    }
  